import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/being10/src/app/contact/ContactClient.tsx");
